import { Component, Input } from '@angular/core';
import { AbstractControl, AbstractControlDirective } from '@angular/forms';

@Component({
  selector: 'show-error',
  template: `
    <ng-container *ngIf="shouldShowErrors()">
      <ul class="list-unstyled mb-0">
        <li *ngFor="let error of listOfErrors()">
          <small class="text-danger">{{ error }}</small>
        </li>
      </ul>
    </ng-container>
  `,
  styleUrls: ['./show-error.component.scss'],
})
export class ShowErrorComponent {
  readonly errorMessages = {
    required: (params: any) =>
      params ? 'Ingrese ' + params : 'Este campo es requerido.',
    minlength: (params: any) =>
      'El mínimo de caracteres permitido es ' + params.requiredLength,
    maxlength: (params: any) =>
      'El máximo de caracteres permitido es ' + params.requiredLength,
    pattern: (_params: any) => 'Formato incorrecto.',
    esmayorhoy: (_params: any) => 'Fecha ingresada no válida',
    esmenorhoy: (_params: any) => 'Fecha ingresada no válida',
    errorformat: (_params: any) => 'Formato de fecha inválido: dd/mm/yyyy',
    fechanoexiste: (_params: any) => 'Fecha ingresada no válida',
    min: (params: any) => 'El valor mínimo permitido es ' + params.min,
    max: (params: any) => 'El valor máximo permitido es ' + params.max,
    soloNumerosEnteros: (_params: any) => 'Ingrese solo números enteros',
    email: (_params: any) => 'Formato incorrecto.',
    passwordMismatch: (_params: any) => 'Las contraseñas no coinciden.',
    server: (params: any) => params || 'Campo inválido.',
  };

  @Input() control!: AbstractControlDirective | AbstractControl | null;
  @Input() label!: string;
  @Input() defaultMessage: boolean = false;

  shouldShowErrors(): boolean {
    return !!(
      this.control &&
      this.control.errors &&
      (this.control.dirty || this.control.touched)
    );
  }

  listOfErrors(): string[] {
    const errors = this.control?.errors;

    if (!errors) return [];

    return Object.keys(errors).map((field) =>
      this.getMessage(field, errors[field])
    );
  }

  private getMessage(type: string, params: any): string {
    if (this.defaultMessage) {
      return 'Formato incorrecto.';
    }

    if (type === 'required') {
      params = this.label;
    }

    if (type === 'pattern') {
      return params?.requiredPattern === '^[0-9]*$'
        ? this.errorMessages.soloNumerosEnteros(params)
        : this.errorMessages.pattern(params);
    }

    const handler =
      this.errorMessages[type as keyof typeof this.errorMessages];

    return handler ? handler(params) : 'Campo inválido.';
  }
}
